import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, CalendarIcon } from 'lucide-react';
import { party, HERO_IMAGE } from '../data/party';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-[var(--night)] text-center" data-id="element-22" data-mp="9kjvgl9o4y23">
      <h1 className="sr-only" data-id="element-23" data-mp="4lql31pohn65">{party.name}</h1>
      <img src={HERO_IMAGE} alt="Kanchella artwork featuring a Palm Springs landscape" className="block h-auto w-full" data-id="element-24" data-mp="4n1jsn49o4qe" />

      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.65,
      delay: 0.15
    }} className="absolute inset-x-0 bottom-0 flex translate-y-[10px] flex-col items-center px-4 py-4 sm:px-8 sm:py-6" data-id="element-25" data-mp="xae5yw6imaj6">
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-semibold text-white sm:text-sm" data-id="element-26" data-mp="neaz5d0pxnpw">
          <span className="flex items-center gap-1.5" data-id="element-27" data-mp="382p91mw8pvpw">
            <CalendarIcon className="h-4 w-4 text-[var(--gold)]" data-id="element-28" data-mp="3814c5qmge0ov" />
            {party.dateLong}, {party.year}
          </span>
          <a href={party.venueMapUrl} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 underline decoration-white/40 underline-offset-4 transition-colors hover:text-[var(--gold)] focus:outline-none focus:ring-2 focus:ring-[var(--gold)] focus:ring-offset-2 focus:ring-offset-[var(--dusk)]" aria-label="Open The Parker Palm Springs in Google Maps" data-id="element-29" data-mp="3o7lrboupx2nw">
            <MapPinIcon className="h-4 w-4 text-[var(--gold)]" data-id="element-30" data-mp="359szpipjof5t" />
            {party.venueName}
          </a>
        </div>
        <motion.a href="#rsvp" whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.97
      }} className="mt-4 rounded-full bg-[var(--gold)] px-5 py-2 font-poster text-base uppercase tracking-[0.12em] text-[var(--night)] shadow-lg shadow-black/20" data-id="element-31" data-mp="2qlepgmpstof8">
          Complete Registration
        </motion.a>
      </motion.div>
    </section>;
}